// eslint-disable-next-line import/prefer-default-export
export function makeSearchParams(page = 1, { limit = 10, search, order } = {}) {
  const params = {
    page, limit,
  };
  if (search && search.length > 2) {
    params.search = search;
  }
  if (order && typeof order === 'object') {
    params.order = order;
  }
  return {
    params, limit, search, order,
  };
}



// WEBPACK FOOTER //
// ./src/utils/params.js